import { observer } from "mobx-react-lite";
import NotebookSidebar from "./sidebar/NotebookSidebar";
import { SidebarResizeHandle } from "./sidebar/SidebarResizeHandle";
import NotebookMainContent from "./NotebookMainContent";

const NotebookLayout = observer(() => {
  return (
    <div className="flex h-[calc(100vh-70px)] bg-white">
      <NotebookSidebar />
      <SidebarResizeHandle />
      <main className="flex min-h-0 min-w-0 flex-1 flex-row">
        <NotebookMainContent />
      </main>
    </div>
  );
});

export default NotebookLayout;
